import { Inline, Layout, styled, Text } from '@lessonnine/design-system.lib';
// External Imports
import React from 'react';

// Internal Imports
import { FILTER_CONTROL } from '../../config/types/prop.mjs';

// Local Variables
const InlineWithRelative = styled(Inline)`
  position: relative;
`;

const HiddenInput = styled.input`
  /* 
    Not using display: none or visibility:hidden 
    here as the inputs need to be in the DOM to receive focus
  */
  cursor: pointer;
  height: 100%;
  left: 0;
  margin: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

const TextRadioLabel = styled(Text)`
  ${({ isSelected, theme }) => `
    color: ${
      isSelected
        ? theme.color.interactive.navigation.foreground.active
        : theme.color.interactive.navigation.foreground.resting
    }
  `}
`;

const Wrapper = styled(Inline)`
  border: solid 1px ${({ theme }) => theme.color.surface.layer.separator};
  border-left: none;
  border-right: none;
`;

// Component Definition
// TODO: The design-system currently doesn't have such controls, it might make sense to check whether they are interesting and if such component should exist in the DS, or if we should review how to do this in accordance with the design-system
function ButtonControl({ label, name, onChange, options, selected }) {
  return (
    <form action="/">
      {}
      <Wrapper gap={{ medium: 48, small: 16 }} padding={[16, 0]}>
        <Text as="label" fontWeight={600} htmlFor={name}>
          {label}
        </Text>
        <Layout
          direction={{ xsmall: 'inline', xxsmall: 'stack' }}
          gap={{ medium: 32, xxsmall: 12 }}
        >
          {options.map(({ label: optionLabel, value }, index) => (
            <InlineWithRelative key={value}>
              <HiddenInput
                checked={value === selected}
                id={`${name}${index}`}
                name={name}
                onChange={(changeEvent) => onChange(changeEvent)}
                type="radio"
                value={value}
              />
              <TextRadioLabel
                as="label"
                fontSize="small"
                fontWeight={600}
                htmlFor={`${name}${index}`}
                isSelected={value === selected}
              >
                {optionLabel.toUpperCase()}
              </TextRadioLabel>
            </InlineWithRelative>
          ))}
        </Layout>
      </Wrapper>
    </form>
  );
}

ButtonControl.propTypes = FILTER_CONTROL;
ButtonControl.defaultProps = {
  defaultLabel: '',
  selected: '',
};

// Module Exports
export { ButtonControl };
